import type { AxiosResponse } from 'axios'

import type { ApiClient } from 'clients/yogi-api'
import type {
  ExportDownload,
  ExportFilters,
} from 'features/projects/features/export/types'

const DATASET_EXPORT_URL = '/client/dataset-export/export'
const PROJECT_DATASET_EXPORT_URL = '/client/dataset-export/project/export'
const HUB_UUID_HEADER = 'X-Hub-UUID'

export class ExportService {
  constructor(private client: ApiClient) {}

  async exportDatasets(filters: ExportFilters): Promise<ExportDownload> {
    const response = await this.client.post<Blob>(DATASET_EXPORT_URL, filters, {
      responseType: 'blob',
    })
    return toExportDownload(response)
  }

  async exportProjectDataset(
    projUuid: string,
    filters: ExportFilters,
  ): Promise<ExportDownload> {
    const response = await this.client.post<Blob>(
      PROJECT_DATASET_EXPORT_URL,
      filters,
      {
        responseType: 'blob',
        headers: { [HUB_UUID_HEADER]: projUuid },
      },
    )
    return toExportDownload(response)
  }
}

/** Translate the transport response into the feature's domain shape. */
function toExportDownload(response: AxiosResponse<Blob>): ExportDownload {
  return {
    blob: response.data,
    filename: readFilename(response.headers['content-disposition']),
  }
}

function readFilename(header: string | string[] | undefined): string | null {
  if (!header) return null
  const headerStr = Array.isArray(header) ? header[0] : header
  if (!headerStr) return null
  const match = /filename="?([^";]+)"?/i.exec(headerStr)
  return match?.[1] ?? null
}
